import React, { ChangeEvent } from 'react';
import { FaChevronDown } from 'react-icons/fa';

export type Option = {
	disabled?: boolean;
	key?: string;
	value: string | null;
	title?: string | null;
};

export interface SelectProps {
	id: string;
	disabled?: boolean;
	value?: string;
	name?: string;
	options?: Option[];
	onChange(value: string): void;
}

export function Select({ id, disabled, value, name, options, onChange }: SelectProps) {
	const handleChangeSelectValue = (item: ChangeEvent<HTMLSelectElement>) => {
		const { target } = item;

		onChange(target.value);
	};

	return (
		<div className='relative w-full'>
			<select
				className={
					'block pl-2.5 pr-6 w-full h-8 border rounded border-gray-300 text-[14px] leading-7 text-black bg-white shadow appearance-none cursor-pointer truncate'
				}
				id={id}
				name={name}
				disabled={disabled}
				value={value || ''}
				onChange={handleChangeSelectValue}
			>
				{options?.map(({ disabled, key, value, title }) => (
					<option disabled={disabled} key={key || value} value={String(value || '')}>
						{title}
					</option>
				))}
			</select>
			<FaChevronDown className='absolute top-1/2 right-2 -translate-y-1/2 w-3 h-3 opacity-80 pointer-events-none' />
		</div>
	);
}
